import {CONTRIBUTORS} from 'data/CONTRIBUTORS'

export const changelog = [
	{
		date: new Date('2025-04-20'),
		Changes: () => <>Add informational display of Swiftcast and Lucid Dreaming usage/cooldown availability adjacent to Defensives.</>,
		contributors: [CONTRIBUTORS.AKAIRYU],
	},
	{
		date: new Date('2024-07-23'),
		Changes: () => <>Initial support, Addle & Swiftcast still in the past for BLU</>,
		contributors: [CONTRIBUTORS.HUGMEIR],
	},
]
